export default function isTheLittleBraCompany() {
  const url = (window.location.href || '').toLowerCase();
  return url.includes('thelittlebracompany');
}
